module.exports = __webpack_public_path__ + "static/media/NoDataYetIllustration.d30511f1.png";